export default __webpack_public_path__ + "static/media/systemowe1.071b85af.jpg";